import { render } from "./EmployeeStatistics.vue?vue&type=template&id=997e886c"
import script from "./EmployeeStatistics.vue?vue&type=script&lang=js"
export * from "./EmployeeStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__